/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavMissionNote
 */
export interface OutputUavMissionNote {
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionNote
     */
    authorId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionNote
     */
    authorName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionNote
     */
    body?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionNote
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionNote
     */
    id?: number;
}

/**
 * Check if a given object implements the OutputUavMissionNote interface.
 */
export function instanceOfOutputUavMissionNote(value: object): boolean {
    return true;
}

export function OutputUavMissionNoteFromJSON(json: any): OutputUavMissionNote {
    return OutputUavMissionNoteFromJSONTyped(json, false);
}

export function OutputUavMissionNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionNote {
    if (json == null) {
        return json;
    }
    return {
        
        'authorId': json['authorId'] == null ? undefined : json['authorId'],
        'authorName': json['authorName'] == null ? undefined : json['authorName'],
        'body': json['body'] == null ? undefined : json['body'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function OutputUavMissionNoteToJSON(value?: OutputUavMissionNote | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'authorId': value['authorId'],
        'authorName': value['authorName'],
        'body': value['body'],
        'createdAt': value['createdAt'],
        'id': value['id'],
    };
}

